import {observer} from 'mobx-react-lite'
import * as React from 'react'
import tw from 'tailwind-styled-components'
import {AddTaskSticker} from './add-task-sticker'
import {useAddTaskStore} from './add-task-store'

const TwStickersPanel = tw.div`
  w-full
  flex
  gap-x-8
  gap-y-6
  flex-wrap
`

export const AddTaskStickers = observer(() => {
  const [state, store] = useAddTaskStore()

  return (
    <div
      data-test-id="add-task-stickers"
      className={`relative ${state.requiredStickers?.length ? 'min-h-24' : ''}`}
    >
      <TwStickersPanel style={{width: 'calc(100% - 22px)'}}>
        {store.requiredStickersExcludeAssignUser.map((sticker, index) => (
          <AddTaskSticker
            key={sticker.tag.id}
            requiredSticker={sticker}
            index={index}
          />
        ))}
      </TwStickersPanel>
      {store.assignUserRequiredSticker && (
        <div className="absolute right-0 bottom-0">
          <AddTaskSticker
            requiredSticker={store.assignUserRequiredSticker}
            index={state.requiredStickers.length}
          />
        </div>
      )}
    </div>
  )
})
